import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash-es';
export const unsubscribeOnDestroy = function (target, observables) {
    const ngOnDestroy = target.prototype.ngOnDestroy;
    target.prototype.ngOnDestroy = function () {
        if (observables === undefined) {
            _.each(this, (subscription) => {
                if (subscription instanceof Subscription && subscription.closed === false) {
                    subscription.unsubscribe();
                }
            });
        }
        else {
            _.each(this, (subscription, key) => {
                _.each(observables, (observableName) => {
                    if (key.includes(observableName)) {
                        if (subscription instanceof Subscription && subscription.closed === false) {
                            subscription.unsubscribe();
                        }
                    }
                });
            });
        }
        if (ngOnDestroy !== undefined) {
            ngOnDestroy.apply(this, arguments);
        }
    };
};
//# sourceMappingURL=unsubscribe-on-destroy.func.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/reactive/decorator/unsubscribe/src/unsubscribe-on-destroy.func.js
// module id = 638
// module chunks = 7